module.exports = __webpack_public_path__ + "static/media/collection-bird-05.2d2d77f0.png";